import { useTranslation } from "react-i18next";
import PropertiesList from 'Components/Personal/Property/PropertiesList';
import MergedContactsViewer from 'Components/Personal/MergedContactsViewer';
import { useContactMetadata } from 'Modules/ContactModule';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Carousel, CarouselControl, CarouselItem, Col, Container, NavLink, Row } from 'reactstrap'; // ProfileListOptions Component

function ProfileListOptions({
  data,
  groupIndex,
  handleMenuClick,
  mergedCount = 0
}) {
  const {
    t
  } = useTranslation();
  return <div className="settings">
      <div className="group">
        {data.map((groupNameData, index) => <div key={groupNameData.name || index} className={"p" + index}>
            <NavLink active={groupIndex === index} onClick={e => handleMenuClick(e, index)}>
              {t(groupNameData.showName)}
            </NavLink>
          </div>)}
        <div key="merged_contacts_tab" className="p_merged mt-2">
          <NavLink 
            active={groupIndex === 'mergedContacts'} 
            onClick={e => handleMenuClick(e, 'mergedContacts')}
            style={{ 
              fontWeight: groupIndex === 'mergedContacts' ? 'bold' : 'normal',
              cursor: 'pointer'
            }}
          >
            👥 {t("Merged Contacts")} {mergedCount > 0 ? `(${mergedCount})` : ''}
          </NavLink>
        </div>
      </div>
    </div>;
}

export default function ProfileList({
  profile,
  setIsOpen
}) {
  const {
    t
  } = useTranslation();
  const data = useContactMetadata(profile.properties);
  const [groupIndex, setGroupIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0); // const [animating, setAnimating] = useState(false)

  const [isMobile, setIsmobile] = useState(true);
  const setActiveState = useCallback(() => {
    console.log('window.outerWidth', window.outerWidth);

    if (window.outerWidth < 800) {
      if (!isMobile) {
        setActiveIndex(0);
      }

      setIsmobile(true);
    } else {
      setIsmobile(false);
      setActiveIndex(0);
    }
  }, [isMobile]);
  const handleResize = useCallback(() => {
    setActiveState();
  }, [setActiveState]);
  useEffect(() => {
    window.addEventListener('resize', handleResize, {
      passive: true
    });
    setActiveState();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize, setActiveState]);

  const menuItemClick = (e, index) => {
    console.log(index);
    setGroupIndex(index);
    setIsOpen(false);

    if (isMobile) {
      next();
    }
  };

  const next = () => {
    console.log('next', 0); //   if (animating) return

    setActiveIndex(1);
  };

  const previous = () => {
    console.log('back', 0); ///   if (animating) return

    setActiveIndex(0);
  };

  if (isMobile) {
    const items = [{
      pane: '1'
    }, {
      pane: '2'
    }];
    const mergedCount = profile?.mergedContacts?.length || 0;
    const panes = items.map(item => {
      if (item.pane === '1' && isMobile === true) {
        return <CarouselItem // onExiting={() => setAnimating(false)} 
        // onExited={() => setAnimating(false)} 
        key={item.pane}>
            <ProfileListOptions data={data} groupIndex={groupIndex} handleMenuClick={menuItemClick} mergedCount={mergedCount} />
          </CarouselItem>;
      } else {
        return <CarouselItem // onExiting={() => setAnimating(false)} 
        // onExited={() => setAnimating(false)} 
        key={item.pane}>
            <Row>
              <Col xs='12' md='9'>
                <Button color='primary' onClick={previous} style={{
                marginBottom: '1rem'
              }}>{t("Back")}</Button>
                {groupIndex === 'mergedContacts' ? (
                  <MergedContactsViewer mergedContacts={profile.mergedContacts} />
                ) : (
                  <PropertiesList profile={profile} groupIndex={groupIndex} />
                )}

              </Col>
            </Row>
          </CarouselItem>;
      }
    });
    console.log('panes', panes);
    const autochange = false;
    return <div>
        <Container className='profilelist fixed' fluid>
          <Row>
            <Col xs='12'>
              <Carousel activeIndex={activeIndex} next={next} previous={previous} interval={autochange}>

                {panes}
                <CarouselControl direction='prev' directionText='Previous' onClickHandler={previous} />
                <CarouselControl direction='next' directionText='Next' onClickHandler={next} />
              </Carousel>
            </Col>
          </Row>
        </Container>
      </div>;
  } else {
    const mergedCount = profile?.mergedContacts?.length || 0;
    return <div>
        <Container className='profilelist fixed' fluid>
          <Row>
            <Col xs='0' md='3' className='mobile'>
              <ProfileListOptions data={data} groupIndex={groupIndex} handleMenuClick={menuItemClick} mergedCount={mergedCount} />
            </Col>
            <Col xs='12' md='9'>
              {groupIndex === 'mergedContacts' ? (
                <MergedContactsViewer mergedContacts={profile.mergedContacts} />
              ) : (
                <PropertiesList profile={profile} groupIndex={groupIndex} />
              )}
            </Col>
          </Row>
        </Container>
      </div>;
  }
}